<template>
  <div class="process-body">
    <HubHeader :fixed="false" />
    <nav class="process-nav">
      <h1><span>HUB</span> <span>EDITOR</span></h1>
      <ul class="process-list">
        <!-- <li class="make" ><button @click="moveToGate">make process or protocol</button></li> -->
        <li class="gate" :data-selected="editorType == 'gate' || editorType == 'gate' ? true : false">
          <button @click="moveToGate"><small>공정도목록</small></button>
        </li>
        <!--실험입력-->
        <div v-if="pageType == pageTypeList[0]">
          <li class="protocol" :data-selected="$route.query.menuType == 'researcher' ? true : false">
            <button @click="clickEditorTabHandler( 'experiment' )">실험입력</button>
          </li>
          <li class="process" v-if="user && (user.admin || user.committee || user.super || user.generalManager)"
              :data-selected="$route.query.menuType == 'manager' ? true : false">
            <button @click="clickEditorTabHandler( 'process' )">공정도</button>
          </li>
        </div>
        <!--시각화-->
        <div v-if="pageType == pageTypeList[1]">
          <li class="visualization"
              :data-selected="$route.query.menuType == 'manager' ? true : false">
            <button @click="clickEditorTabHandler( 'visualization' )">시각화</button>
          </li>
        </div>
      </ul>
    </nav>
<!--    <releasePopup v-if="SaveLogPopup" :openFlag.sync="SaveLogPopup"/>-->
    <router-view :key="$route.fullPath"/>
    <registDictionaryPopup :key="registDictionaryPopupKey" :forceReRender.sync="registDictionaryPopupKey"></registDictionaryPopup>
    <!-- layer modal 영역-->
    <ExperimentType/>
    <EditAttribute/>
    <EditAttributePool/>
    <ConnectProtocol></ConnectProtocol>
    <SearchProtocol/>
    <ProtocolDetail/>
    <FileUpload></FileUpload>
    <ResultConfirm></ResultConfirm>
    <SaveHistory></SaveHistory>
    <VersionHistory></VersionHistory>
    <VisualizationPopup></VisualizationPopup>
    <KeshImageService></KeshImageService>
<!--    <NodeMarkSetting></NodeMarkSetting>-->
    <TagOptionPopTagAddList />
  </div>
</template>

<script>
import TagOptionPopTagAddList from '@components/TagAddPop/TagOptionPopTagAddList' ;
import registDictionaryPopup from '@nav_process/Editor/comp/registDictionaryPopup' ;
// import { commNewMapGetters , commNewMapMutations } from "@processEditor/CommNew";
import CommNew from "@processEditor/CommNew";
import ExperimentType from "@/components/modal/ExperimentType";
import EditAttribute from "@/components/modal/EditAttribute";
import CustomModal from "@/components/modal/customModal";
import SaveHistory from "@/components/modal/SaveHistorty";
import FileUpload from "@/components/modal/FileUpload";
import ResultConfirm from "@/components/modal/ResultConfirm";
import NodeMarkSetting from "@/components/modal/NodeMarkSetting";
import VersionHistory from "@/components/modal/VersionHistory";
import VisualizationPopup from "@/components/modal/VisualizationPopup";
import EditAttributePool from "@/components/modal/EditAttributePool";
import ConnectProtocol from "@/components/modal/ConnectProtocol";
import SearchProtocol from "@/components/modal/SearchProtocol";
import ProtocolDetail from "@/components/modal/ProtocolDetail";
import KeshImageService from "@/components/modal/KeshImageService";
import HubHeader from "@/components/layout/HubHeader.vue";
export default {
  name: "process-editor",
  mixins : [ CommNew ] ,
  order:1,
  components : {
    HubHeader,
    SaveHistory,
    NodeMarkSetting,
    ResultConfirm,
    FileUpload,
    CustomModal,
    EditAttribute,
    ExperimentType,
    TagOptionPopTagAddList,
    registDictionaryPopup,
    VersionHistory,
    EditAttributePool,
    ConnectProtocol,
    SearchProtocol,
    ProtocolDetail,
    KeshImageService,
    VisualizationPopup,
  } ,
  data() {
    return {
      editorType: '',
      registDictionaryPopupKey: 0,
      pageTypeList: ['experiment', 'visualization'],
      pageType: '',
      // SaveLogPopup: false,
    };
  },
  watch: {
    async $route(value) {
      this.editorType = value.query.editorType;
      if( value.path === '/protocol/gate' || value.path === '/experiment/gate' || value.path === '/visualization/gate' ){
        this.editorType = 'gate';
      }      
      await this.setPageType(value.path);
    }
  },
  async mounted() {
    await this.setPageType(this.$route.path);
    await this.setProcess_N_UserInfo() ;
    // console.log( "user", this.user )
    this.editorType = this.$route.query.editorType || '';
    if( this.$route.path === '/protocol/gate' || this.$route.path === '/process/gate' ){
        this.editorType = 'gate';
    }          
    if( this.$route.path === '/protocol/equiment' ){
        this.editorType = 'equiment';
    }          
  },
  methods: {
    recodeEditorUrl() {
      const { fullPath, path, query } = this.$route ; 
      sessionStorage.setItem( 'editor-url' , JSON.stringify( { fullPath, path, query } )) ; 
    },
    async clickEditorTabHandler(menuType) {
      let sessionData = JSON.parse(sessionStorage.getItem('editor-url'));
      let path = `/${menuType}/editor`;
      let query = {
        processId: this.processId,
        editorType: 'process',
        menuType: menuType == 'experiment' ? 'researcher' : 'manager',
      }

      if(!this.processId) {
        sessionData = JSON.parse(sessionStorage.getItem('editor-url'));
        if( sessionData ){
          path = sessionData.path;
          query = sessionData.query;
        }
      } 

      if(!query.processId ){
        await window.alert(`<span class='text-14 fw-400'>최근 열어본 문서가 없습니다.</span> <h6 class='text-16 fw-600 mt-1' style='text-align:center;'>공정도목록으로 이동합니다.</h6>`,{
            okTitle: "확인",
            okVariant: "platform",
          });
        if(this.pageType == this.pageTypeList[0]) {
          this.editorType = 'gate';
          this.$router.push({
            path: '/experiment/gate', query: {}
          });
        }else if(this.pageType == this.pageTypeList[1]){
          this.$router.push({
            path: '/visualization/gate', query: {}
          });
        }
        return;
      }

      if( menuType === 'process' && query.processId ){
        /** 로그 등록 */
        await this.$wApi.trace.log({
          type : 'PD', //PD 공정도, EX 실험
          code : 'R', //N 생성 M 수정 S 검색 R 조회
          subCode : '01',
          keyword : '',
          result : 1,
          ptlId : query.processId
        });
        /** 로그 등록 */    
      }else{
        /** 로그 등록 */
        await this.$wApi.trace.log({
          type : 'EX', //PD 공정도, EX 실험
          code : 'R', //N 생성 M 수정 S 검색 R 조회
          subCode : '01',
          keyword : '',
          result : 1,
          ptlId : query.processId
        });
        /** 로그 등록 */
      }
    
      //console.log( "$route.fullPath", this.$route.fullPath )
      this.$router.push({
        path, query
      });
    },
    moveToGate() {
      this.recodeEditorUrl();
      if(this.pageType == this.pageTypeList[0]) {
        this.editorType = 'gate';
        if (this.$route.query.menuType) {
          const menu = this.$route.query.menuType == "manager" ? "process" : "experiment"
          this.$router.push({path: `/${menu}/gate`, query: {editorType: "gate"}});
        } else {
          this.$router.push({path: `/experiment/gate`, query: {editorType: "gate"}});
        }
      }else if(this.pageType == this.pageTypeList[1]){
        this.$router.push({path: `/visualization/gate`, query: {editorType: "gate"}});
      }
    },
    async setPageType(path) {
      for (const checkPageType of this.pageTypeList){
        if(path.includes(checkPageType)){
          this.pageType = checkPageType;
        }
      }
      if(this.pageType == ''){
        this.pageType = this.pageTypeList[0];  
      }
    },
  },
}
</script>

<style lang='scss'>
@import '@/style/reset.scss';
html, body, #app {
  height: 100%;
}
.process-body {
  --nav-bg-color: #f7f8fa;
  --nav-bd-color: #e3e7ee;
  --nav-navy: #003f67;

  display: grid;
  grid-template:
    'header header' auto
    'nav content' 1fr /
    var( --process-nav-width ) 1fr
  ;
  min-height: 100%;
  height: 100%;

  > .hub-header {
    grid-area: header;
  }

  .process-nav {
    grid-area: nav;
    display: grid;
    grid-template:
      'process' 1fr
      'title' auto
      / auto
    ;
    z-index: 100;
    position: relative;
    background-color: var(--nav-bg-color);
    border-right: 1px solid var(--nav-bd-color);
    overflow: hidden;

    h1 {
      grid-area: title;
      width: 10px;
      padding: 40px 0 28px 18px;
      word-break: break-all;
      color: #9aa3b2;
      font-size: 12px; font-weight: 600; letter-spacing: .08em;
      text-align: center;

      span {
        display: inline-block;
        margin-top: 10px;
      }
    }
    .process-list {
      grid-area: process;
      display: flex; flex-direction: column; align-items: end; 
      gap: 7px;
      padding: 0; margin: 0;
      margin-top:10px;
      li {
        width: 64px; height: 64px;
        border: 1px solid var( --nav-bd-color );
        border-right: 0;
        border-top-left-radius: 8px; border-bottom-left-radius: 8px;
        overflow: hidden;
        font-size: 14px; @include text-prt-sb;
        box-shadow: 0px 2px 6px rgba(16, 24, 40, 0.06);

        a , button {
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          width: 100%; height: 100%;
          color: #4b5260;
          background-color: #fff;
          text-decoration: none;
          small{font-size:12px;}
          &::before {
            content:'';
            display: block;
            width: 24px; height: 24px;
            margin: 0 0 4px 0;
            -webkit-filter: brightness(0%);
            filter: brightness(0%);
            opacity: .7;
          }
        }
        a:hover , button:hover {
          background-color: #f3f6fa;
          color: var(--nav-navy);
        }
        &.make {
          display: inline-flex; align-items: center; justify-content: center;
          // width: 32px; height: 32px; 
          border: 0;
          background: url('../../assets/icons/icon-home.svg') center no-repeat;
          background-size: 40px;
          font-size: 0;
        }

        &[data-selected="true"] {
          border-color: var(--nav-navy);
        }
        &[data-selected="true"] a ,
        &[data-selected="true"] button {
          background-color: var(--nav-navy);
          color: #fff;
          &::before {
            -webkit-filter: brightness(500%);
            filter: brightness(500%);
            opacity: 1;
          }
        }


        &.process button::before {background: url('../../assets/icons/icon-process.svg') center no-repeat;}
        &.protocol button::before {background: url('../../assets/icons/icon-protocol.svg') center no-repeat;}
        &.equiment button::before {background: url('../../assets/icons/icon-equipment.svg') center no-repeat;}
        &.gate button::before {background: url('../../assets/icons/icon-gate.svg') center no-repeat;}
        &.visualization button::before {background: url('../../assets/icons/icon_visualization.svg') center no-repeat;}
        &.equiment,&.gate{
          letter-spacing: -0.07em;
        }
      }
    }
  }
  .process-content {
    grid-area: content;
    height: 100%;
    overflow: auto;
  }

  .tmpBox {
    position: fixed; 
    left: 0px; top: 0px; 
    z-index: 999; 
  }
}
</style>

